module.exports = __webpack_public_path__ + "static/media/24UHCHR16.cdc698f5.jpg";